import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
import { EventRegistryAspectDraggable } from './EventRegistryAspectDraggable';
export class EventRegistryAspect extends EventRegistryCategory {
    label = 'Aspect';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_draggable = new EventRegistryAspectDraggable(this);
    default = () => new EventRegistryItem({ handlerName: 'onNever' });
    aspectmount = () => new EventRegistryItem({ handlerName: 'onAspectMount' });
    custom = () => new EventRegistryItem({ handlerName: 'onCustom' });
    traitbecomeactive = () => new EventRegistryItem({
        handlerName: 'onTraitBecomeActive',
    });
    traitbecomeinactive = () => new EventRegistryItem({
        handlerName: 'onTraitBecomeInactive',
    });
    directclick = new EventRegistryItem({
        // direct click on DOM Node (without bubbling)
        handlerName: 'onDirectClick',
        derivesFrom: 'click',
    });
    semidirectclick = new EventRegistryItem({
        // click on Aspect or its own elements (without bubbling to another aspect)
        handlerName: 'onSemiDirectClick',
        derivesFrom: 'click',
    });
    hovertime = () => new EventRegistryItem({
        handlerName: 'onHoverTime',
        // derivesFrom: 'mouseover',
        params: { core: ['timespanInMilliseconds'] },
    });
}
